import useAPI from '@/hooks/useAPI';
import ConstantsRepository from '@/repositories/ConstantsRepository';

const useConstants = (enabled = true) => {
  const constantsRepository = ConstantsRepository();

  return useAPI({
    queryKey: ['getConstants'],
    queryFn: async () => {
      return await constantsRepository.getConstants();
    },
    enabled
  });
};

export default useConstants;
